import { z } from 'zod';
/** Дата без времени и часового пояса: план живёт в календарных днях, а не в моментах. */
export const DateOnlySchema = z.iso.date();
/** Момент времени в ISO-8601 с зоной. */
export const TimestampSchema = z.iso.datetime({ offset: true });
export const UuidSchema = z.uuid();
/** Ключ задачи Jira: PROJ-123. */
export const IssueKeySchema = z
    .string()
    .trim()
    .regex(/^[A-Z][A-Z0-9_]*-\d+$/u, 'issue key');
/** Идентификатор аккаунта Atlassian. */
export const AccountIdSchema = z.string().trim().min(1).max(128);
/** Идентификатор поля Jira: system-имя или customfield_10412. */
export const FieldIdSchema = z
    .string()
    .trim()
    .regex(/^[a-zA-Z][a-zA-Z0-9_]*$/u, 'field id');
/** Диапазон планирования: одна или две недели. */
export const RangeDaysSchema = z.union([z.literal(7), z.literal(14)]);
export const ProgressSchema = z.number().int().min(0).max(100);
/**
 * Страница результатов с курсором. Бесконечная прокрутка листает кэш в PostgreSQL:
 * курсор непрозрачен для клиента, внутри — пара «поле сортировки + ключ задачи».
 */
export function pageOf(item) {
    return z.object({
        items: z.array(item),
        nextCursor: z.string().nullable(),
        /** Всего в выборке; null, если точное число неизвестно. */
        total: z.number().int().nonnegative().nullable(),
    });
}
/** Состояние свежести данных: показывается подписью «Синхронизировано N минут назад». */
export const FreshnessSchema = z.object({
    fetchedAt: TimestampSchema.nullable(),
    /** true — данные отданы из кэша, обновление уже поставлено в очередь. */
    stale: z.boolean(),
});
//# sourceMappingURL=common.js.map